import React from "react";

//Full screen photo viewer - arrow keys / swipe to move, Escape to close
const Lightbox = ({ images, index, onChange, onClose }) => {
  const closeRef = React.useRef(null);
  const touchStart = React.useRef(null);
  const count = images.length;

  const prev = () => onChange((index - 1 + count) % count);
  const next = () => onChange((index + 1) % count);

  React.useEffect(() => {
    const previousFocus = document.activeElement;
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    closeRef.current.focus();
    return () => {
      document.body.style.overflow = overflow;
      if (previousFocus) {
        previousFocus.focus();
      }
    };
  }, []);

  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
      else if (e.key === "ArrowLeft") {
        prev();
      }
      else if (e.key === "ArrowRight") {
        next();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [index]);

  const image = images[index];

  return (
    <div
      className={"lightbox"}
      role={"dialog"}
      aria-modal={"true"}
      aria-label={"Photo viewer"}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
      onTouchStart={(e) => {
        touchStart.current = e.touches[0].clientX;
      }}
      onTouchEnd={(e) => {
        if (touchStart.current === null) {
          return;
        }
        const dx = e.changedTouches[0].clientX - touchStart.current;
        touchStart.current = null;
        if (Math.abs(dx) > 50) {
          if (dx > 0) {
            prev();
          }
          else {
            next();
          }
        }
      }}
    >
      <img
        className={"lightbox-image"}
        src={image.full}
        alt={image.alt}
      />
      <p className={"lightbox-count"}>{`${index + 1} / ${count}`}</p>
      <button
        ref={closeRef}
        type={"button"}
        className={"lightbox-close"}
        onClick={onClose}
      >
        <span className={"visually-hidden"}>Close</span>
        <span aria-hidden={"true"}>×</span>
      </button>
      <button
        type={"button"}
        className={"lightbox-nav prev"}
        onClick={prev}
      >
        <span className={"visually-hidden"}>Previous photo</span>
      </button>
      <button
        type={"button"}
        className={"lightbox-nav next"}
        onClick={next}
      >
        <span className={"visually-hidden"}>Next photo</span>
      </button>
    </div>
  );
};

export default Lightbox;
